// Doc Manager Categories
// If you check a checkbox the chkColor class is added to give a
// background color
// If it is not checked or unchecked it removes the class
$('body').on('click', 'div.cats label input:checkbox', function () {
  $('input:checked').parent().addClass('chkColor');
  $('input:not(:checked)').parent().removeClass('chkColor');
});
